<template>
  <v-form
    ref="form"
    v-model="valid"
    @submit.prevent="onSubmit"
  >
    <v-card
      height="100%"
      flat
    >
      <v-card-title>
        <slot name="form-title">
          <span class="font-weight-semibold text-base text--primary">
            {{ $t("Ajouter une évaluation auteur") }}
          </span>

          <v-spacer />

          <v-btn
            icon
            small
            @click="$emit('update:is-form-active', false)"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </slot>
      </v-card-title>

      <v-card-text
        class="overflow-y-auto"
        style="max-height: 500px;"
      >
        <v-row class="pt-5">

          <!-- Profil -->
          <v-col cols="12">
            <v-text-field
              v-model="item.profile"
              outlined
              dense
              :rules="[validators.required]"
              :error-messages="errorMessages.profile"
              :label="$t('Profil')"
              :placeholder="$t('Profil')"
              hide-details="auto"
            />
          </v-col>

          <!-- Caractéristique -->
          <v-col cols="12">
            <v-textarea
              v-model="item.caracteristic"
              outlined
              dense
              rows="3"
              :rules="[validators.required]"
              :error-messages="errorMessages.caracteristic"
              :label="$t('Caractéristique')"
              :placeholder="$t('Caractéristique')"
              hide-details="auto"
            />
          </v-col>

          <!-- Niveau d'accompagnement -->
          <v-col cols="12">
            <v-textarea
              v-model="item.level_of_support"
              outlined
              dense
              rows="3"
              :rules="[validators.required]"
              :error-messages="errorMessages.level_of_support"
              :label="$t('Niveau d\'accompagnement')"
              :placeholder="$t('Niveau d\'accompagnement')"
              hide-details="auto"
            />
          </v-col>

        </v-row>
      </v-card-text>

      <v-card-actions>
        <slot name="form-actions">
          <slot name="form-cancel">
          </slot>

          <v-spacer />

          <v-btn
            :loading="loading"
            color="primary"
            class="me-3"
            type="submit"
          >
            {{ $t("Enregistrer") }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import {
  mdiClose,
  mdiPencilOutline,
  mdiPencilOffOutline,
} from '@mdi/js'
import { computed, ref } from '@vue/composition-api'
import { required } from '@core/utils/validation'
import store from '@/store'
import controller from './Controller'

export default {
  model: {
    prop: 'object',
    event: 'update:object',
  },

  props: {
    object: {
      type: Object,
      default: () => ({}),
    },

    isFormActive: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const {
      form,
      isSnackbarBottomVisible,
      snackBarMessage,
    } = controller()

    const errorMessages = ref({})
    const valid = ref(false)
    const loading = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const item = computed({
      get: () => props.object,
      set: value => emit('update:object', value),
    })

    const resetItem = () => {
    }

    const onSubmit = () => {
      if (!valid.value) {
        validate()
        return
      }

      loading.value = true

      store
        .dispatch('authorEvaluation/addItem', item.value)
        .then(response => {
          loading.value = false

          if (
            response.data.error
            || response.data.errors
            || (
              response.data.status
              && response.data.status === 'false'
            )
          ) {
            if (response.data.errors) {
              errorMessages.value = {
                ...response.data.errors,
              }
            } else {
              isSnackbarBottomVisible.value = true
              snackBarMessage.value = response.data.message
            }

            return false
          }

          resetItem()

          emit('refetch-data')
        })
        .catch(error => {
          loading.value = false
          console.log('error', error)

          if (error.response && error.response.data.errors) {
            errorMessages.value = {
              ...error.response.data.errors,
            }
          }
        })
    }

    return {
      form,
      isSnackbarBottomVisible,
      snackBarMessage,
      errorMessages,
      onSubmit,
      item,
      valid,
      loading,
      validate,

      validators: {
        required,
      },

      icons: {
        mdiClose,
        mdiPencilOffOutline,
        mdiPencilOutline,
      },
    }
  },
}
</script>
